import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalFormSubmission } from "./types";

// GET /api/portal/forms/:slug/submissions/:id — confirmation read used by
// the post-submit page. The slug is purely cosmetic for URL parity; the
// worker keys off (submissionId, session.partnerId).
export function useFormSubmission(
  slug: string | undefined,
  submissionId: string | null,
) {
  return useQuery<PortalFormSubmission, ApiClientError>({
    queryKey: queryKeys.portal.forms.submission(submissionId ?? ""),
    queryFn: () =>
      apiFetch<PortalFormSubmission>(
        `/portal/forms/${slug}/submissions/${submissionId}`,
      ),
    enabled: !!slug && !!submissionId,
  });
}
